import { usePatients, usePatientsSort, useUpdateSort } from '../../../../../features/patients';
import { Sort } from '../../../sort';
import { IPatientsSortProps } from './types';

export const PatientsSort = ({ by }: IPatientsSortProps) => {
  const updateSort = useUpdateSort();
  const { status } = usePatients();
  const sort = usePatientsSort();

  return <Sort baseTranslationKey="patients.table" by={by} sort={sort} status={status} updateSort={updateSort} />;
};
